import {Button, CreateIcon, ModalPopup, SmallLoader} from '@kit';

import React, {Suspense, lazy, useState} from 'react';

import {useCharacterSheetsQuery} from '../../generated/types';
import {Link} from '../../lib/routes';
import {SheetSummary, useTitleLookups} from '../sheets/sheet-summary';

import css from './my-sheets.module.css';

const LIMIT = 3;

const NewCharacterEditor = lazy(() =>
	import('../sheets/character/master/creation-master').then((module) => ({default: module.NewCharacterEditor})),
);

export const MySheets: React.FC = () => {
	const {data, refetch} = useCharacterSheetsQuery({ssr: false, fetchPolicy: 'cache-and-network'});
	const [isCreating, setCreating] = useState(false);
	const titles = useTitleLookups();
	const sheets = [...(data?.characterSheets || [])]
		.sort((first, second) => second.updatedAt.localeCompare(first.updatedAt))
		.slice(0, LIMIT);

	const closeCreation = () => {
		setCreating(false);
		refetch();
	};

	return (
		<section className={css.block} aria-labelledby="home-my-sheets">
			<div className={css.header}>
				<h2 id="home-my-sheets" className={css.title}>
					Мои бланки персонажей
				</h2>
				<Button link route="sheets">
					Все бланки
				</Button>
			</div>
			{data && !sheets.length ? (
				<p className={css.empty}>
					У вас пока нет персонажей. Бланк создаётся за несколько шагов, а считает за вас всё остальное.
				</p>
			) : (
				<ul className={css.list}>
					{sheets.map((sheet) => (
						<li key={sheet.id}>
							<Link route="sheet" params={{id: sheet.id}} className={css.sheet}>
								<span className={css.name}>{sheet.name || 'Безымянный персонаж'}</span>
								<SheetSummary sheet={sheet} titles={titles} />
							</Link>
						</li>
					))}
				</ul>
			)}
			<div className={css.footer}>
				<Button appearance="primary" icon={<CreateIcon />} onClick={() => setCreating(true)}>
					Новый персонаж
				</Button>
			</div>
			{isCreating && (
				<ModalPopup open onClose={closeCreation} header="Новый персонаж" maxWidth={800}>
					<Suspense fallback={<SmallLoader />}>
						<NewCharacterEditor />
					</Suspense>
				</ModalPopup>
			)}
		</section>
	);
};
